import { createMintSocketBuilder } from '@mint-lib/api-zod-support/socket';
import z from 'zod';

import { MediaDataSchema } from '../mediaData/index.js';
import { planningGridViewTypeEnum } from '../shared/schemas/columns.js';

export const socket = createMintSocketBuilder({
  onValidationError: (error) => {
    console.error(error);
  },
});

const roomPayloadSchema = z.object({
  room: z.enum(['general', 'activity', 'flight', 'media_plan']),
  entityId: z.string(),
});

export const flightUpdatePayloadSchema = z.object({
  id: z.string(),
  isNameUpdated: z.boolean(),
});

export const mediaLineDeletedPayloadSchema = z.object({
  data: z.object({ id: z.string() }),
});

export const mediaLineCreatedPayloadSchema = z.object({
  data: z.record(z.string(), z.unknown()),
  parentId: z.string(),
});

export const mediaLineUpdatedPayloadSchema = z.object({
  data: MediaDataSchema,
});

export const mediaPlanTotalsUpdatedPayloadSchema = z.record(
  z.string(),
  z.unknown(),
);

export const planningColumnsUpdatedPayloadSchema = z
  .object({
    views: z.array(planningGridViewTypeEnum).optional(),
  })
  .nullish();

export const joinRoom = socket.defineSend({
  topic: 'join',
  payloadSchema: roomPayloadSchema,
});

export const leaveRoom = socket.defineSend({
  topic: 'leave',
  payloadSchema: roomPayloadSchema,
});

export const onJoinFailed = socket.defineSubscribe({
  topic: 'join_failed',
  payloadSchema: z.unknown(),
});

export const onActivityCreated = socket.defineSubscribe({
  topic: 'activity_created',
  payloadSchema: z.unknown(),
});

export const onActivityDeleted = socket.defineSubscribe({
  topic: 'activity_deleted',
  payloadSchema: z.unknown(),
});

export const onActivityUpdated = socket.defineSubscribe({
  topic: 'activity_updated',
  payloadSchema: z.unknown(),
});

export const onFlightCreated = socket.defineSubscribe({
  topic: 'flight_created',
  payloadSchema: z.unknown(),
});

export const onFlightUpdated = socket.defineSubscribe({
  topic: 'flight_updated',
  payloadSchema: flightUpdatePayloadSchema,
});

export const onFlightDeleted = socket.defineSubscribe({
  topic: 'flight_deleted',
  payloadSchema: z.unknown(),
});

export const onMediaLineDeleted = socket.defineSubscribe({
  topic: 'media_line_deleted',
  payloadSchema: mediaLineDeletedPayloadSchema,
});

export const onMediaLineCreated = socket.defineSubscribe({
  topic: 'media_line_created',
  payloadSchema: mediaLineCreatedPayloadSchema,
});

export const onMediaLineUpdated = socket.defineSubscribe({
  topic: 'media_line_updated',
  payloadSchema: mediaLineUpdatedPayloadSchema,
});

export const onMediaPlanTotalsUpdated = socket.defineSubscribe({
  topic: 'media_plan_totals_updated',
  payloadSchema: MediaDataSchema,
});

export const onMediaPlanSummaryUpdated = socket.defineSubscribe({
  topic: 'media_plan_summary_updated',
  payloadSchema: z.unknown(),
});

export const onActivitySummaryUpdated = socket.defineSubscribe({
  topic: 'activity_summary_updated',
  payloadSchema: z.unknown(),
});

export const onFlightSummaryUpdated = socket.defineSubscribe({
  topic: 'flight_summary_updated',
  payloadSchema: z.unknown(),
});

export const onPlanningColumnsUpdated = socket.defineSubscribe({
  topic: 'planning_columns_updated',
  payloadSchema: planningColumnsUpdatedPayloadSchema,
});
